import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slider,
  Typography,
} from '@mui/material';
import Cropper from 'react-easy-crop';

export default function AvatarCropDialog({
  open,
  imageSrc,
  saving,
  onCancel,
  onConfirm,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  useEffect(() => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  }, [imageSrc]);

  const handleConfirm = () => {
    if (croppedAreaPixels) {
      onConfirm(croppedAreaPixels);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onCancel}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Crop Avatar Image</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: 320, sm: 420 },
            bgcolor: 'common.black',
            overflow: 'hidden',
            borderRadius: 1,
          }}
        >
          {imageSrc && (
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={(_croppedArea, nextCroppedAreaPixels) => {
                setCroppedAreaPixels(nextCroppedAreaPixels);
              }}
            />
          )}
        </Box>

        <Box sx={{ mt: 2, px: 1 }}>
          <Typography variant="body2" gutterBottom>
            Zoom
          </Typography>
          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.01}
            onChange={(_event, value) => setZoom(value)}
            disabled={saving}
            aria-label="Avatar zoom"
          />
          <Typography variant="caption" color="text.secondary">
            Drag the image to position it inside the circle.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleConfirm}
          disabled={saving || !croppedAreaPixels}
        >
          {saving ? 'Uploading...' : 'Save Avatar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
